<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}

.space{
  margin: 150px 20px 20px 20px;
}

.coming-soon{
  font-size: 16px;
  color: white;
  text-align: center;
}

.icon-sad{
  font-size: 30px;
}

</style>

{#if goAhead }

<div class="bg">
  <div class="title-signup">First things first.  What type of account are you creating?</div>
  <div class="margin">
    <button on:click="{business}" disabled>Business Profile</button>
    <div class="coming-soon">(coming soon)</div>
  </div>
  <div class="margin">
    <button on:click="{personal}">Personal Profile</button>
  </div>
  
  <div class="margin link" on:click="{ () => push('/login') }">Already have an account?</div>
  
</div>

{:else}

<div class="center space">
  <i class="icon-sad"></i>
  <p>We're sorry, your invite code was missing or invalid.</p>
  <p>We're in a private Beta period right now, and the only way to use HOT is to be invited.</p>
  <p><button on:click="{ () => document.location = 'https://hangingout.today' }">Go Home</button></p>
  <p>or</p>
  <p><button on:click="{ () => push('/login') }">Log In</button></p>
</div>

{/if}

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import Signup from "../../../../helpers/Signup.js";

let goAhead = false;

import { onMount } from "svelte";
onMount(async () => {
  
  // if signup is already complete, then we push the user outta here...
  let signupComplete = Signup.getPersonalObject("signupComplete");
  if (signupComplete == true) {
    document.location = "/";
    return;
  }
  
  // need the JSON.parse because v comes back as a string, not a boolean
  let v = JSON.parse( localStorage.getItem("v") );
  let vc = localStorage.getItem("vc");
  
  if (v == true && vc != "") {
    goAhead = true;
  }
  
});

function business() {
  // push("");
}


function personal() {
  Signup.createPersonalDefault();
  
  push("/signup/profile/personal/init");
}


</script>